export default __webpack_public_path__ + "static/media/15.b0ad06ea.JPG";